import * as CapacityActions from './../../store/capacity/capacity.actions';
import {selectCapacity} from '../../store/capacity/capacity.adapter';
import {Store} from '@ngrx/store';
import {Capacity} from '../../shared/models/capacity.model';
import { DateTime } from 'luxon';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {CapacityState} from '../../store/capacity/capacity.reducer';


export interface CapacityOverrideFormValues {
  selectedDate: string;
}

@Component({
  selector: 'app-capacity-override',
  templateUrl: './capacity-override.component.html',
  styleUrls: ['./capacity-override.component.scss']
})
export class CapacityOverrideComponent implements OnDestroy, OnInit {

  overrideCapForm: UntypedFormGroup;
  subscriptions: Subscription[] = [];

  minDate;

  isLoading$: Observable<boolean>;
  capacity$: Observable<Capacity[]>;
  selectedCapacity$: Observable<Capacity>;



  private dispatchActions() {
    this.capacityStore.dispatch(new CapacityActions.LoadCapacity());
  }

  refresh() {
    this.dispatchActions();
  }

  constructor(private readonly capacityStore: Store<CapacityState>,
              private readonly formBuilder: UntypedFormBuilder) {
    // this.isLoading$ = this.capacityStore.select(selectCapacityLoading);
    this.capacity$ = this.capacityStore.select(selectCapacity);
    this.dispatchActions();
    this.minDate = DateTime.local().toFormat('yyyy-MM-dd');
    this.overrideCapForm = this.formBuilder.group({
      selectedDate: new UntypedFormControl(this.minDate)
    });

    setTimeout(() => {
      this.capacityStore.dispatch(new CapacityActions.LoadCapacityForDate(this.minDate));
    }, 0);

    this.subscriptions.push(
      this.overrideCapForm.valueChanges.subscribe(value => {
        this.capacityStore.dispatch(new CapacityActions.LoadCapacityForDate(value.selectedDate));
      })
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }



}
